import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { FormlyFieldConfig } from "@ngx-formly/core";

export class VNumberValidators {
    static isEmptyInputValue(value: any): boolean {
        return value == null || value.length === 0;
    }

    static greaterThan(rightControlPath: string, leftControlPath: string): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const leftControl = formGroup.get(leftControlPath);
            const rightControl = formGroup.get(rightControlPath);

            if (!leftControl || !rightControl) {
                return null;
            }

            if (rightControl.hasError("greaterThan")) {
                delete rightControl.errors.mustMatch;
                rightControl.updateValueAndValidity();
            }

            if (this.isEmptyInputValue(rightControl.value) || this.isEmptyInputValue(leftControl.value)) {
                return null;
            }

            const leftValue = leftControl.value as number;
            const rightValue = rightControl.value as number;

            if (rightValue > leftValue) {
                return null;
            }

            const errors = { greaterThan: true };

            rightControl.setErrors(errors);

            return errors;
        };
    }
}

export function minItemsValidator(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
    const min = field.validators?.validation?.[0]?.options?.limit as number;

    if (min === undefined) {
        return null;
    }

    const isValid = control.value && Array.isArray(control.value) && control.value.length >= min;

    return isValid ? null : { minItems: { required: min, actual: control.value.length } };
}

export function minItemsValidationMessage(err: any, field: FormlyFieldConfig) {
    return field.templateOptions?.minItemsMessage;
}

export function dumAndDppOrderValidator(control: AbstractControl): ValidationErrors | null {
    const dumControl = control.get("dum");
    const dppControl = control.get("dpp");

    if (!dumControl?.value || !dppControl?.value) {
        return null;
    }

    const dum = new Date(dumControl.value);
    const dpp = new Date(dppControl.value);

    if (dum >= dpp) {
        return { dateOrder: true };
    }

    return null;
}

export function dateNotInFutureValidator(control: AbstractControl, field: FormlyFieldConfig): ValidationErrors | null {
    const dateValue = control.value;

    if (!dateValue) {
        return null;
    }

    const inputDate = new Date(dateValue);
    const today = new Date();

    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const isValid = inputDate <= today;

    return isValid ? null : { dateNotInFuture: true };
}

export function dateNotInFutureValidationMessage(err: any, field: FormlyFieldConfig) {
    return field.templateOptions?.dateNotInFutureMessage || "A data não pode ser futura.";
}
